<template>


<transition name="fade" v-on:after-leave="completeOut" v-on:after-enter="completeIn">
    
      <div  v-if="show" v-on:click="userClear" class="container">
        <div class="message"><font-awesome-icon class="icon" v-bind='{icon:"lightbulb"}'/>{{message}}</div>
        <div class="close"><font-awesome-icon v-bind='{icon:"times"}'/></div>
      </div>
   
  </transition>

</template>

<script>

export default {
  name: 'toast',
  props:{
    message:{default:"no-message"},
  },
  computed:{
    
  },
  data(){
    return {
      show:false,
      timeout:undefined,
    }
  },
  mounted(){
   

    this.show=true;
  },
  methods:{
    completeOut: function () {
      // animate out done:
      this.$emit('removeToast',this);
    },
    completeIn: function () {
      // wait for animating out
      
      this.timeout=setTimeout(() => {
        this.show=false;
      }, 3000);
    },
    userClear:function(){
      
      clearTimeout(this.timeout);
      this.show=false;
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  margin:5px 10px;
  position:relative;
  cursor:pointer;
  display:flex;
  background-color:rgba(0,0,0,.8);
  color:#FFFFFF;
  padding:10px;
  border-radius:4px;
  margin-top:5px;
  font-size:1em;
}
.message{
  flex:1;
}
.fade-enter-active, .fade-leave-active{
  transition: opacity .35s, font-size.35s, padding .35s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
  font-size:0;
  padding:0;
 
}
.icon{
  color:#ffe200;
  margin-right:15px;
}
</style>
